import { useCallback } from "react";
import { atom, PrimitiveAtom, useAtom } from "jotai";

import { Api } from "interfaces";

import { useGetTypesForFile } from "modules/data-files/api";
import { useCreateProjectWithDataAndWorkspace } from "modules/projects/api";

import * as flowConfig from "flows/profile-discovery/config";

import {
  useGetInputFile,
  useGetIDColumns,
  useGetAttributeColumns,
} from "./params";

const projectCreateStatus = atom<"not-started" | "in-progress" | "completed">(
  "not-started"
);

const projectCreateError = atom<string | Api.ApiError>(null) as PrimitiveAtom<
  string | Api.ApiError
>;

export const useGetCreate = () => {
  const createProject = useCreateProjectWithDataAndWorkspace();

  const inputFile = useGetInputFile();
  const colTypes = useGetTypesForFile(inputFile);
  const idColumns = useGetIDColumns();
  const attributeColumns = useGetAttributeColumns();

  const [status, setStatus] = useAtom(projectCreateStatus);
  const [error, setError] = useAtom(projectCreateError);

  const create = useCallback(async () => {
    if (!inputFile || idColumns.length <= 0 || attributeColumns.length <= 0) {
      setError("Input Data, ID-Columns, and Attributes ARE ALL MANDATORY!!!");
      return;
    }
    setStatus("in-progress");
    setError(null);
    const projectSpec = {
      flow: flowConfig.FLOW_NAME,
      data_files: { [flowConfig.INPUT_DATA]: inputFile },
      meta_data: {
        [flowConfig.ID_COLUMNS_KEY]: idColumns,
        [flowConfig.ATTRIBUTE_COLUMNS_KEY]: attributeColumns,
      },
    };
    const workspaceSpec = {
      key: "init",
      recipe: flowConfig.RECIPE_NAME,
      input_data: { [flowConfig.INPUT_DATA]: [inputFile] },
      cleanup_spec: { [inputFile]: {} },
      variable_mapping: {
        [flowConfig.ID_COLUMNS_KEY]: idColumns,
        [flowConfig.ATTRIBUTE_COLUMNS_KEY]: attributeColumns,
      },
      model_params: {},
    };

    const resp = await createProject({
      "project-spec": projectSpec,
      "workspace-spec": workspaceSpec,
    });

    if (resp.success) {
    } else if (resp.success === false) {
      setError(resp.error);
    }
    setStatus("completed");
    return resp;
  }, [inputFile, idColumns, attributeColumns, colTypes]);

  return [create, status, error] as const;
};
